import { Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { CompanySettingsWrapper } from './company-settings.styles';
import { AbsenceReasons } from './components/absence-reasons';
import { ProjectTaskTemplates } from './components/project-test-templates';
import { UserPosition } from './components/user-position';

const CompanySettings = () => {
  const { t } = useTranslation('common');

  return (
    <CompanySettingsWrapper>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('labels.companySettings')}
      </Typography>
      <UserPosition />
      <AbsenceReasons />
      <ProjectTaskTemplates />
    </CompanySettingsWrapper>
  );
};

export default CompanySettings;
